export class SessionStorageWrapper {
  #store;
  #getFullKey;

  constructor(getFullKey = (key) => key) {
    this.#store = typeof window !== 'undefined' ? window.sessionStorage : null;
    this.#getFullKey = getFullKey;
  }

  setItem(key, value) {
    if (this.#store) {
      this.#store.setItem(this.#getFullKey(key), value);
    }
  }

  getItem(key) {
    if (this.#store) {
      return this.#store.getItem(this.#getFullKey(key));
    }
    return undefined;
  }
}
